// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style.css
// module id = 2
// module chunks = 0